/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 13.06.2016
 *
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { ConfirmFormContainer, flagHOC, FormActions, ScrollableDataListRV } from 'plugin/liferay-widgets-react-web';

import MapConfigListItem from './MapConfigListItem';

const ScrollableDataListRVHOC = flagHOC(ScrollableDataListRV, ['list']);

class MapConfigChooser extends React.Component {

    constructor(props){
        super(props);

        this.DATA = {
            FORM_DELETE_CONFIRM: 'MapConfigChooserDeleteConfirm'
        };
    }

    onSelect(item, e){
        this.props.onSelect(item);
    }

    onDelete(item){
        FormActions.startEditFormItem(this.DATA.FORM_DELETE_CONFIRM, item);
    }

    handleSubmitDeleteMapConfigModal(item){
        this.props.onDelete(item);
        FormActions.stopEditFormItem(this.DATA.FORM_DELETE_CONFIRM);
    }

    render(){
        const { mapConfigs } = this.props;

        return (
            <React.Fragment>
                <h3 className="widget-title"> Kartenkonfigurationen </h3>

                <p> Bitte wählen Sie eine Kartenkonfiguration aus, um diese zu bearbeiten. </p>

                <ScrollableDataListRVHOC
                    list={mapConfigs}
                    size="medium"
                    className="map-config-map-config-list"
                    ListItem={MapConfigListItem}
                    onClick={this.onSelect.bind(this)}
                    onDelete={this.onDelete.bind(this)}
                />

                <ConfirmFormContainer
                    editRequired={false}
                    submitButtonText='Löschen'
                    formId={this.DATA.FORM_DELETE_CONFIRM}
                    onFormSubmit={this.handleSubmitDeleteMapConfigModal.bind(this)}
                    Content={({ formData }) => (
                        'Wollen Sie die Kartenkonfiguration \'' + (formData.item || formData).title + '\' wirklich löschen?'
                    )}
                />
            </React.Fragment>
        );
    }
}

MapConfigChooser.propTypes = {
    mapConfigs: PropTypes.object,
    onSelect: PropTypes.func,
    onDelete: PropTypes.func
};

export default MapConfigChooser;



// WEBPACK FOOTER //
// ./js/components/MapConfigChooser.jsx